import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthApiService } from '../../../services/auth.api.service';
import { NonjointApplicantService } from '../../../services/loan/nonjoint-applicant.api.service';
import { UserState } from '../../../states/user-state';

@Component({
  selector: 'app-nonjoint-invite',
  templateUrl: './nonjoint-invite.component.html',
  styleUrl: './nonjoint-invite.component.scss',
  standalone: false,
})
export class NonjointInviteComponent {
  isLoading = true;
  message: string | null = null;
  error: string | null = null;
  isAuthenticated = false;

  token: string | null = null;
  loanId: string | null = null;
  applicantEmail: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authApi: AuthApiService,
    private nonjointApi: NonjointApplicantService,
    private userState: UserState
  ) {}

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token');
    if (!this.token) {
      this.isLoading = false;
      this.error = 'Missing invitation token.';
      return;
    }

    this.authApi.lookupNonjointInvite(this.token).subscribe({
      next: (res) => {
        this.loanId = res?.loanId || null;
        this.applicantEmail = res?.applicantEmail ?? null;

        this.isAuthenticated = !!this.userState.getUser()?.token;
        if (this.isAuthenticated) {
          this.acceptInvite();
        } else {
          this.isLoading = false;
          this.message = 'You’ve been invited as a co-applicant. Please sign in or create an account to continue.';
        }
      },
      error: (err) => {
        console.error('Nonjoint invite lookup failed', err);
        this.isLoading = false;
        this.error = err?.error?.message || 'Invalid or expired invitation link.';
      },
    });
  }

  private acceptInvite() {
    if (!this.token) return;
    this.nonjointApi.acceptInvite(this.token).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.message = res?.message || 'Invitation accepted.';
      },
      error: (err) => {
        console.error('Accept invite failed', err);
        this.isLoading = false;
        this.error = err?.error?.message || 'Failed to accept invitation.';
      },
    });
  }

  goToLogin = (_e?: Event) => {
    this.router.navigate(['/login'], {
      queryParams: {
        email: this.applicantEmail || undefined,
        inviteToken: this.token || undefined,
      },
    });
  };

  goToSignup = (_e?: Event) => {
    this.router.navigate(['/signup'], {
      queryParams: {
        loanId: this.loanId || undefined,
        email: this.applicantEmail || undefined,
        inviteToken: this.token || undefined,
      },
    });
  };

  goToApplications = (_e?: Event) => {
    this.router.navigate(['/loan/application-list']);
  };
}

